import React from 'react';
import { translateWithI18Next } from '@kfc-global/kfc-i18n/lib';
import { TRANSLATE_MAPPING_KEY } from 'common/constants/i18nTranslateKeys';

const LegalInformationDescription = ({ showLegalInfo, isMobile }) => {
  const { LEGALINFOTEXT1, LEGALINFOTEXT2 } = TRANSLATE_MAPPING_KEY;
  return showLegalInfo ? (
    <div
      className={`${(isMobile && 'pdp-mobile-legal-info-container') || 'pdp-legal-info-container'}`}
      data-testid='pdp-legal-info'
    >
      <div>
        <div className='legal-info-desc'>
          {translateWithI18Next(LEGALINFOTEXT1)}
          <br></br>
          {translateWithI18Next(LEGALINFOTEXT2)}
        </div>
      </div>
    </div>
  ) : (
    <></>
  );
};
export default LegalInformationDescription;
